import {ImageItem} from "../../../../../model/items/imageItem";
import {LabelItem} from "../../../../../model/items/labelItem";
import {TextboxItem} from "../../../../../model/items/textbox";

export default class PointDefinition {
    constructor(
        public readonly imageItem: ImageItem,
        public readonly labelItem: LabelItem,
        public readonly xItem: TextboxItem,
        public readonly yItem: TextboxItem,
    ) { }

    public get imageUrl(): string {
        return this.imageItem.questionary.getFileUrl(this.imageItem.file);
    }

    public get label(): string {
        return this.labelItem.label ?? '';
    }

    public get x(): number|null {
        return this.textItemToNumber(this.xItem)
    }

    public set x(value: number|null) {
         this.numberToTextItem(this.xItem, value)
    }

    public get y(): number|null {
        return this.textItemToNumber(this.yItem)
    }

    public set y(value: number|null) {
        this.numberToTextItem(this.yItem, value)
    }

    public isPlaced(): boolean {
        return typeof this.x === 'number' && typeof this.y === 'number';
    }

    private textItemToNumber(textItem: TextboxItem): number|null {
        const value = textItem.getVariable();
        return (value === null || value === undefined) ? null : Number(value);
    }

    private numberToTextItem(textItem: TextboxItem, value: number|null): void {
        textItem.set(value ?? undefined)
    }

}